// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__88Ccg","title":"ClientReferral_title__Iw0Pg","itemText":"ClientReferral_itemText__2jdIL"};